import card0 from "@/assets/individual_cards/card_001.jpg";
import card1 from "@/assets/individual_cards/card_002.jpg";
import card2 from "@/assets/individual_cards/card_003.jpg";
import card3 from "@/assets/individual_cards/card_004.jpg";
import card4 from "@/assets/individual_cards/card_005.jpg";
import card5 from "@/assets/individual_cards/card_006.jpg";
import card6 from "@/assets/individual_cards/card_007.jpg";
import card7 from "@/assets/individual_cards/card_008.jpg";
import card8 from "@/assets/individual_cards/card_009.jpg";
import card9 from "@/assets/individual_cards/card_010.jpg";
import card10 from "@/assets/individual_cards/card_011.jpg";
import card11 from "@/assets/individual_cards/card_012.jpg";
import card12 from "@/assets/individual_cards/card_013.jpg";
import card13 from "@/assets/individual_cards/card_014.jpg";
import card14 from "@/assets/individual_cards/card_015.jpg";
import card15 from "@/assets/individual_cards/card_016.jpg";
import card16 from "@/assets/individual_cards/card_017.jpg";
import card17 from "@/assets/individual_cards/card_018.jpg";
import card18 from "@/assets/individual_cards/card_019.jpg";
import card19 from "@/assets/individual_cards/card_020.jpg";
import card20 from "@/assets/individual_cards/card_021.jpg";
import card21 from "@/assets/individual_cards/card_022.jpg";
import card22 from "@/assets/individual_cards/card_023.jpg";
import card23 from "@/assets/individual_cards/card_024.jpg";
import card24 from "@/assets/individual_cards/card_025.jpg";
import card25 from "@/assets/individual_cards/card_026.jpg";
import card26 from "@/assets/individual_cards/card_027.jpg";
import card27 from "@/assets/individual_cards/card_028.jpg";
import card28 from "@/assets/individual_cards/card_029.jpg";
import card29 from "@/assets/individual_cards/card_030.jpg";
import card30 from "@/assets/individual_cards/card_031.jpg";
import card31 from "@/assets/individual_cards/card_032.jpg";
import card32 from "@/assets/individual_cards/card_033.jpg";
import card33 from "@/assets/individual_cards/card_034.jpg";
import card34 from "@/assets/individual_cards/card_035.jpg";
import card35 from "@/assets/individual_cards/card_036.jpg";
import card36 from "@/assets/individual_cards/card_037.jpg";
import card37 from "@/assets/individual_cards/card_038.jpg";
import card38 from "@/assets/individual_cards/card_039.jpg";
import card39 from "@/assets/individual_cards/card_040.jpg";
import card40 from "@/assets/individual_cards/card_041.jpg";
import card41 from "@/assets/individual_cards/card_042.jpg";
import card42 from "@/assets/individual_cards/card_043.jpg";
import card43 from "@/assets/individual_cards/card_044.jpg";
import card44 from "@/assets/individual_cards/card_045.jpg";
import card45 from "@/assets/individual_cards/card_046.jpg";
import card46 from "@/assets/individual_cards/card_047.jpg";
import card47 from "@/assets/individual_cards/card_048.jpg";
import card48 from "@/assets/individual_cards/card_049.jpg";
import card49 from "@/assets/individual_cards/card_050.jpg";
import card50 from "@/assets/individual_cards/card_051.jpg";
import card51 from "@/assets/individual_cards/card_052.jpg";
import card52 from "@/assets/individual_cards/card_053.jpg";
import card53 from "@/assets/individual_cards/card_054.jpg";
import card54 from "@/assets/individual_cards/card_055.jpg";
import card55 from "@/assets/individual_cards/card_056.jpg";
import card56 from "@/assets/individual_cards/card_057.jpg";
import card57 from "@/assets/individual_cards/card_058.jpg";
import card58 from "@/assets/individual_cards/card_059.jpg";
import card59 from "@/assets/individual_cards/card_060.jpg";
import card60 from "@/assets/individual_cards/card_061.jpg";
import card61 from "@/assets/individual_cards/card_062.jpg";
import card62 from "@/assets/individual_cards/card_063.jpg";
import card63 from "@/assets/individual_cards/card_064.jpg";
import card64 from "@/assets/individual_cards/card_065.jpg";
import card65 from "@/assets/individual_cards/card_066.jpg";
import card66 from "@/assets/individual_cards/card_067.jpg";
import card67 from "@/assets/individual_cards/card_068.jpg";
import card68 from "@/assets/individual_cards/card_069.jpg";
import card69 from "@/assets/individual_cards/card_070.jpg";
import card70 from "@/assets/individual_cards/card_071.jpg";
import card71 from "@/assets/individual_cards/card_072.jpg";
import card72 from "@/assets/individual_cards/card_073.jpg";
import card73 from "@/assets/individual_cards/card_074.jpg";
import card74 from "@/assets/individual_cards/card_075.jpg";
import card75 from "@/assets/individual_cards/card_076.jpg";
import card76 from "@/assets/individual_cards/card_077.jpg";
import card77 from "@/assets/individual_cards/card_078.jpg";

export const cardsImages = [
    card0,
    card1,
    card2,
    card3,
    card4,
    card5,
    card6,
    card7,
    card8,
    card9,
    card10,
    card11,
    card12,
    card13,
    card14,
    card15,
    card16,
    card17,
    card18,
    card19,
    card20,
    card21,
    card22,
    card23,
    card24,
    card25,
    card26,
    card27,
    card28,
    card29,
    card30,
    card31,
    card32,
    card33,
    card34,
    card35,
    card36,
    card37,
    card38,
    card39,
    card40,
    card41,
    card42,
    card43,
    card44,
    card45,
    card46,
    card47,
    card48,
    card49,
    card50,
    card51,
    card52,
    card53,
    card54,
    card55,
    card56,
    card57,
    card58,
    card59,
    card60,
    card61,
    card62,
    card63,
    card64,
    card65,
    card66,
    card67,
    card68,
    card69,
    card70,
    card71,
    card72,
    card73,
    card74,
    card75,
    card76,
    card77,
]